import { showMessage } from 'app/messages/actions';
import { connect } from 'react-redux';
import { connectLiveLinks } from '../../../live-links';
import { type ContentPreviewSlice, closePreview, selectPreviewRoute, setIframe, setPreviewRoute } from '../../slice';
import ContentPreview, { type ContentPreviewStateProps } from './content-preview';

function mapStateToProps(state: ContentPreviewSlice): ContentPreviewStateProps {
  const selection = selectPreviewRoute(state);
  return {
    selection
  };
}

const mapDispatchToProps = {
  closePreview,
  setPreviewRoute,
  setIframe,
  showMessage
};

export default connectLiveLinks(connect(mapStateToProps, mapDispatchToProps)(ContentPreview));
